export default {
  UPDATE_FAVORITE: "UPDATE_FAVORITE",
};
